import { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Auth } from "aws-amplify";

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [auth, setAuth] = useState("");
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const user = await Auth.currentSession();
        setIsAuthenticated(true);
        setAuth(user);
        // setCheckedAuth(true);
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setCheckedAuth(true);
      }
    };
    checkAuthStatus();
  }, []);

  if (!checkedAuth) {
    return null; // Não renderiza até que a verificação seja concluída
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return <Outlet context={[auth, setAuth]} />;
};
export default ProtectedRoute;
